import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import { AuthenticatedUserConsumer } from '../../AuthenticatedUserContext'
import PageTitle from '../Dashboard/PageTitle/PageTitle'
import AdminForm from './AdminForm'
import BreadCrumb from '../Dashboard/BreadCrumb'
import { NamedRoutes } from '../../routes'

const AddAdminContent = ({ getRoles, adminSectionType }) => {
  const classes = useStyles()
  React.useEffect(() => {
      if (!!getRoles) {
        getRoles()
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Users'/>,
          link: NamedRoutes[adminSectionType].user.list
        }
      ]} current={<FormattedMessage id='AddAdmin.title'/>}/>
      <PageTitle title={<FormattedMessage id='AddAdmin.title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <AuthenticatedUserConsumer>
              {({ addAdminSubmit, resetAddAdminStatus, roles }) => (
                !!roles && !!roles.length &&
                <AdminForm onSubmit={addAdminSubmit} resetAddAdminStatus={resetAddAdminStatus} roles={roles}/>
              )}
            </AuthenticatedUserConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default AddAdminContent
